export enum SIDE {
  left = "left",
  right = "right",
}
export const SIDES = [SIDE.left, SIDE.right] as const;
export type Side = typeof SIDES[number];
